import { createBrowserRouter } from "react-router-dom";
import Home from "../app/home";
import Tracking from "../app/tracking";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
    },
    {
        path: "/tracking",
        element: <Tracking />,
    },
]);

export default router;